var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "studentMessageCenter" }, [
    _c(
      "div",
      { staticClass: "studentMessageCenter-left" },
      [
        _c("Title", {
          staticClass: "studentMessageCenter-title",
          attrs: { text: "消息中心" },
        }),
        _c(
          "div",
          { staticClass: "studentMessageCenter-tabs mat20" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { name: "system" } },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: { value: _vm.MessageReceivesList.count },
                          },
                          [_c("i", { staticClass: "iconfont iconshengyin" })]
                        ),
                        _vm._v("系统消息"),
                      ],
                      1
                    ),
                    _c(
                      "el-scrollbar",
                      [
                        _vm._l(
                          _vm.MessageReceivesList.list,
                          function (value, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "studentMessageCenter-MsgList",
                                class: {
                                  activeList: _vm.currentIndex === index,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCurrentData(value, index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { class: { isRead: value.is_read } },
                                  [_vm._v(_vm._s(value.title))]
                                ),
                                _c("em", [_vm._v(_vm._s(value.created_at))]),
                              ]
                            )
                          }
                        ),
                        _vm.MessageReceivesList.list.length > 0
                          ? _c("el-pagination", {
                              attrs: {
                                layout: "prev, pager, next",
                                "page-size": _vm.limit,
                                total: _vm.total,
                              },
                              on: { "current-change": _vm.handleChange },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "studentMessageCenter-right",
        class: { activeStudent: !Object.keys(_vm.currentData).length },
      },
      [
        Object.keys(_vm.currentData).length !== 0
          ? _c("div", [
              _c("div", { staticClass: "studentMessageCenter-title" }, [
                _vm.currentData.title
                  ? _c("span", [_vm._v(_vm._s(_vm.currentData.title))])
                  : _vm._e(),
                _vm.currentData.question
                  ? _c("span", [_vm._v(_vm._s(_vm.currentData.question))])
                  : _vm._e(),
                _vm.currentData.created_at
                  ? _c("em", [_vm._v(_vm._s(_vm.currentData.created_at))])
                  : _vm._e(),
                _c("em"),
              ]),
              _vm.currentData.content
                ? _c("div", { staticClass: "studentMessageCenter-content" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.currentData.content) },
                    }),
                  ])
                : _vm._e(),
              _vm.currentData.answer
                ? _c("div", { staticClass: "studentMessageCenter-content" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.currentData.answer) },
                    }),
                  ])
                : _vm._e(),
            ])
          : _c("ComponentEmpty", { attrs: { title: "暂无数据", tips: "" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }